export default __webpack_public_path__ + "cac1ad4a774d8d5d0d11e770b1d338e6.ico";